module.exports = __webpack_public_path__ + "img/00_ux-indonesia.dc9c80d3.jpg";